module.exports = __webpack_public_path__ + "media/loader_brandme_ia.35ca3b78.mp4";